<template>
  <div class="blocks">
    <div v-for="(block1, index1) in blockList" :key="index1 + '0'">
      <div :class="block1.styleType == 1 ? 'block-1-port' : block1.styleType == 2 ? 'block-2-port' : block1.styleType == 3 ? 'block-3-port' : 'block-4-port'">
        <div
          :class="block1.styleType == 3 ? 'block-3-port-o' : block1.styleType == 4 ? 'block-4-port-o' : ''"
          v-for="(block, index) in block1.columnistBlockList"
          :key="index"
          @click="toDetail(block.jumpType, block.jumpUrl)"
        >
          <img :class="block1.styleType == 1 ? 'block1' : block1.styleType == 2 ? 'block2' : block1.styleType == 3 ? 'block3' : 'block4'" :src="block.picUrl" alt="">
          <div v-if="block1.styleType == 3 || block1.styleType == 4" :class="block1.styleType == 3 ? 'block3-name' : 'block4-name'">{{ block.blockName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Blocks',
  props: {
    blockList: Array
  },
  methods: {
    toDetail(type, url) {
      if (type == 1) {
        //专栏
        this.$router.push('/ColumnDetail?uuid=' + url + '&sou=' + this.$route.query.sou)
      } else if (type == 2) {
        //专题
        this.$router.push('/TopicDetail?uuid=' + url + '&sou=' + this.$route.query.sou)
      } else if (type == 3) {
        //外链
        window.location.href = url
      } else {
        return
      }
    }
  }
}
</script>
<style lang="less" scoped>
.blocks {
  margin-top: 24px;
}
@media screen and (min-width: 1000px) {
  .block-1-port {
    > div {
      width: 654px !important;
      height: 136px !important;
    }
  }
  .block-2-port {
    > div {
      width: 323px !important;
      height: 136px !important;
    }
  }
}
.block-1-port {
  margin: 0 18px 8px;
  > div {
    // po
    width: calc(100vw - 36px);
    height: calc((100vw - 36px) * 17 / 68);
    margin-top: 8px;
    
  }
  .block1 {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
}
@media screen and (min-width: 1000px) {
  .block-2-port {
    grid-template-columns: repeat(2, 323px) !important;
  }
}
.block-2-port {
  margin: 8px 18px 0;
  display: grid;
  grid-template-columns: repeat(2, calc((100vw - 44px) / 2));
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  // display: flex;
  // justify-content: space-between;
  > div {
    width: calc((100vw - 44px) / 2);
    height: calc((100vw - 36px) * 17 / 68);
  }
  .block2 {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
}

.block-3-port {
  margin: 8px 0 8px 18px;
  display: flex;
  overflow-x: scroll;
  // justify-content: space-around;
  &-o {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
  }
  .block3 {
    width: 56px;
    height: 56px;
    border-radius: 100%;
  }

  .block3-name {
    font-size: 14px;
    color: #454556;
    line-height: 20px;
  }
}
@media screen and (min-width: 1000px) {
  .block-4-port {
    margin: 8px 18px 0;
    display: grid;
    grid-template-columns: repeat(4, 163px) !important;
  }
}
.block-4-port {
  margin: 8px 18px 0;
  display: grid;
  grid-template-columns: repeat(4, calc((100vw - 36px) / 4));
  &-o {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin: 0px 12px;
    margin-bottom: 8px;
  }
  .block4 {
    width: 56px;
    height: 56px;
    border-radius: 100%;
  }

  .block4-name {
    font-size: 14px;
    color: #454556;
    line-height: 20px;
  }
}
</style>
